import React, { useEffect, useRef, useState } from "react";
import { isUndefined } from "lodash";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Label } from "@client.components/Modal";
import DropdownUserRoles from "@client.components/DropdownUserRoles";
import { useSelector } from "react-redux";
import { makeAvailableRoles } from "@client.pages/Settings/reducer";

const DropdownUserRolesComponent = ({
  error,
  selectedRole,
  onSelect,
  disabled,
}) => {
  const { t } = useTranslation();
  const availableRoles = useSelector(makeAvailableRoles);
  const [roleDescription, setRoleDescription] = useState(null);
  const roleRef = useRef(null);

  useEffect(() => {
    if (!isUndefined(selectedRole)) {
      const item = roleRef.current.getItem(selectedRole);
      if (item) setRoleDescription(item.description);
    }
  }, [selectedRole]);

  return (
    <>
      <Label term="components.UserManagementContent.role" />
      <DropdownUserRoles
        id="roles"
        disabled={disabled}
        error={error}
        placeholder={t("components.UserManagementContent.placeholder.role")}
        ref={roleRef}
        items={availableRoles}
        showDescription
        defaultValue={selectedRole}
        onSelect={(v, item) => {
          onSelect(v, item);
        }}
      />
      {roleDescription && <div></div>}
      {roleDescription && (
        <div className="role-description">{roleDescription}</div>
      )}
    </>
  );
};

DropdownUserRolesComponent.defaultValue = {
  selectedRole: undefined,
};

DropdownUserRolesComponent.propTypes = {
  error: PropTypes.array,
  selectedRole: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DropdownUserRolesComponent;
